import { Logger } from '../../logger/Logger';
import { DEFAULT_LANGUAGE_CODE } from '../../utils/language';
import { AppManifest } from '../appManifest/AppManifest';
import { DictionaryType } from '../dictionary/constants';
import { DictionaryFetcher } from '../dictionary/DictionaryFetcher';
import { DictionaryService } from '../dictionary/DictionaryService';
import { DictionaryValueFormatter } from '../dictionary/DictionaryValueFormatter';
import { PluralFormatter } from '../dictionary/PluralFormatter';
import type { DictionaryFragment } from '../dictionary/types';

import type { TranslationFile } from './types';

const uiDictionaryFetcher = new DictionaryFetcher<TranslationFile>(
  DictionaryType.UI,
  AppManifest.getPackage('UItranslations')?.version ?? 'latest',
  {
    onError: (file, locale): void => {
      Logger.logFailure('fetch', {
        place: 'translationDictionaryFetcher',
        additional: `${file}-${locale}`,
      });
    },
    parseFile: (file): DictionaryFragment => {
      return file.game;
    },
    fallbackLocale: DEFAULT_LANGUAGE_CODE,
  }
);

const uiValueFormatter = new DictionaryValueFormatter({
  pluralFormatter: new PluralFormatter(),
});

export const UITranslations = new DictionaryService(uiDictionaryFetcher, uiValueFormatter);

UITranslations.addEventListener('no-translation', (key): void => {
  Logger.logFailedTranslation(key, UITranslations.languageHandle);
  console.warn(`[UI Translations] No translation found for key: ${key}`);
});

UITranslations.addEventListener('fetch-failed', () => {
  Logger.logFailure('fetch', {
    place: 'UITranslations',
    additional: UITranslations.languageHandle,
  });
});
